import type { Phase } from "@src/packages/cycles/hooks/useCycles";

/**
 * A phase with the same start and end date is the API's explicit skip marker.
 * A scheduled phase has no end date. Neither is evidence that a procedure
 * happened, so the wait must only start after a strictly completed procedure.
 */
export function isConfirmedProcedurePhase(
  phase: Pick<Phase, "startDate" | "endDate"> | null | undefined,
): boolean {
  if (!phase?.startDate || !phase.endDate) return false;
  return phase.endDate > phase.startDate;
}

/**
 * Pregnancy waiting is valid only after a confirmed transfer or insemination.
 * In particular, a transfer phase whose dates are equal is the explicit
 * freeze-all/no-transfer branch and must never create a beta wait.
 */
export function hasConfirmedPregnancyProcedure(
  phases: readonly Pick<Phase, "type" | "startDate" | "endDate">[],
): boolean {
  return phases.some(
    (phase) =>
      (phase.type === "transfer" || phase.type === "insemination") &&
      isConfirmedProcedurePhase(phase),
  );
}
